import {AxiosRequestConfig} from "axios";

const config: AxiosRequestConfig = {
    baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
    headers: {
        'Accept': 'application/json',
    },
};

export default config;